export type AgentModule = 'sale-contract' | 'purchase-contract'

export type AgentActionType =
  | 'OPEN_FORM'
  | 'SELECT_ROW'
  | 'SET_FIELD'
  | 'SAVE_FORM'
  | 'CANCEL_FORM'
  | 'GET_STATE'

export interface AgentAction {
  type: AgentActionType
  module?: AgentModule
  payload?: Record<string, unknown>
}

export interface AgentActionResult {
  action: AgentAction
  status: 'success' | 'blocked' | 'needs_input'
  message: string
}

export interface AgentActionPlanResponse {
  reply: string
  actions: AgentAction[]
}

const VALID_TYPES: AgentActionType[] = [
  'OPEN_FORM',
  'SELECT_ROW',
  'SET_FIELD',
  'SAVE_FORM',
  'CANCEL_FORM',
  'GET_STATE',
]

const VALID_MODULES: AgentModule[] = ['sale-contract', 'purchase-contract']

export function normalizeAgentPlan(raw: unknown): AgentActionPlanResponse {
  if (!raw || typeof raw !== 'object') {
    return { reply: 'Không nhận được kế hoạch thao tác hợp lệ từ Agent.', actions: [] }
  }

  const maybe = raw as { reply?: unknown; actions?: unknown[] }
  const reply = typeof maybe.reply === 'string' ? maybe.reply : 'Đã nhận lệnh.'

  const actions: AgentAction[] = []
  if (Array.isArray(maybe.actions)) {
    for (const item of maybe.actions) {
      if (!item || typeof item !== 'object') continue
      const obj = item as { type?: unknown; module?: unknown; payload?: unknown }
      if (typeof obj.type !== 'string' || !VALID_TYPES.includes(obj.type as AgentActionType)) continue
      if (obj.module && (typeof obj.module !== 'string' || !VALID_MODULES.includes(obj.module as AgentModule))) {
        continue
      }
      actions.push({
        type: obj.type as AgentActionType,
        ...(obj.module ? { module: obj.module as AgentModule } : {}),
        ...(obj.payload && typeof obj.payload === 'object'
          ? { payload: obj.payload as Record<string, unknown> }
          : {}),
      })
    }
  }

  return { reply, actions }
}
